export default "__VITE_PUBLIC_ASSET__dd60b364__"